export const FETCH_METAL_COLOR_REQUEST = 'FETCH_METAL_COLOR_REQUEST';
export const FETCH_METAL_COLOR_SUCCESS = 'FETCH_METAL_COLOR_SUCCESS';
export const FETCH_METAL_COLOR_FAILURE = 'FETCH_METAL_COLOR_FAILURE';

export const ADD_METAL_COLOR_REQUEST = 'ADD_METAL_COLOR_REQUEST';
export const ADD_METAL_COLOR_SUCCESS = 'ADD_METAL_COLOR_SUCCESS';
export const ADD_METAL_COLOR_FAILURE = 'ADD_METAL_COLOR_FAILURE';

export const UPDATE_METAL_COLOR_REQUEST = 'UPDATE_METAL_COLOR_REQUEST';
export const UPDATE_METAL_COLOR_SUCCESS = 'UPDATE_METAL_COLOR_SUCCESS';
export const UPDATE_METAL_COLOR_FAILURE = 'UPDATE_METAL_COLOR_FAILURE';

export const DELETE_METAL_COLOR_REQUEST = 'DELETE_METAL_COLOR_REQUEST';
export const DELETE_METAL_COLOR_SUCCESS = 'DELETE_METAL_COLOR_SUCCESS';
export const DELETE_METAL_COLOR_FAILURE = 'DELETE_METAL_COLOR_FAILURE';

export const METAL_COLOR_FORM_ERROR = 'METAL_COLOR_FORM_ERROR';
export const METAL_COLOR_FORM_SUCCESS = 'METAL_COLOR_FORM_SUCCESS';
export const SET_METAL_COLOR_EDIT = 'SET_METAL_COLOR_EDIT';
export const CLEAR_METAL_COLOR_EDIT = 'CLEAR_METAL_COLOR_EDIT'; 